(ns practitest.frontend.components2.dashboard.charts.line
  (:require [practitest.frontend.components2.dashboard.charts.line.chart :as render]
              [practitest.frontend.components2.dashboard.chart :as-alias chart]
              [practitest.frontend.components2.dashboard.charts.protocol :as p]
              [practitest.frontend.components2.dashboard.transforms.line :as transforms]
              [practitest.frontend.components2.dashboard.events :as-alias events]
              [practitest.frontend.components2.dashboard.charts.line.helper :as helper]
              [re-frame.core :as rf]))


(def ^:private planned-vs-executed-configs
  #:config
  {:comment-text            ["dashboards.planned-executed.chart.comment"
                             "Planned lines shows only instances with Planned Executed Date"]
   :comment-top-offset       50
   :line-configs {:planned {:line-width 1.5 :line-name "Planned"}
                  :executed {:line-width 1.5 :line-name "Executed"}}})

(def ^:private chart-config
  #:config
  {:height                   250
   :padding                  {:top 30 :right 20 :bottom 40 :left 40}
   :marker-radius            3.25
   :legend-item-width        100
   :legend-top-offset        40
   :draw-grid?               true
   :remove-y-axis-line?      true
   :show-legend?             true
   :define-fn                (fn [d] (some? (aget d "y-data")))
   :parse-date-fn            helper/get-parse-data
   :x-axis-name              "Date"
   :y-data-minimum-value     10
   :parse-date-format        "%Y-%b-%d"
   :date-format-for-x-axis   "%Y-%m-%d"
   :int-format-for-digit-axis "d"
   :x-axis-rotate-label-angle -45
   :x-offset-after-rotation  {:x -10 :y 0 :dy 10}
   :animation                {:line-draw-duration   1200
                              :line-draw-ease       :d3/ease-cubic-out
                              :toggle-out-duration  300
                              :resize-duration      350
                              :resize-ease          :d3/ease-cubic-in-out
                              :marker-in-duration   150
                              :marker-out-duration  100}})

(def ^:private config
  (merge chart-config planned-vs-executed-configs))

(defmethod p/render! ::chart/line [chart ctx svg-element]
  (let [toggle-evt #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        ctx        (merge config ctx {:on-legend-click toggle-evt
                                      :hidden-lines helper/hidden-lines-set})]
    (render/line-chart! svg-element chart ctx)))

(defmethod p/transform-data ::chart/line [item]
  (transforms/transform-planned-vs-executed (merge item config)))
